var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.anchor)?_c('div',{directives:[{name:"clickaway",rawName:"v-clickaway",value:(_vm.emitClose),expression:"emitClose"}],staticClass:"ae-popover",style:(_vm.style)},[_vm._t("default")],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }